import { createSelector } from 'reselect';

const selectShippingModes = (state: any) => state.shippingModes;


export const selectShippingModesCurrentItem = createSelector([selectShippingModes], (shippingModes) => shippingModes.current);

export const selectShippingModesListItems = createSelector([selectShippingModes], (shippingModes) => shippingModes.list);

export const selectShippingModesItemById = (itemId: any) =>
    createSelector(selectShippingModesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectShippingModesQueryItems = createSelector([selectShippingModes], (shippingModes) => shippingModes.query);

export const selectShippingModesCreatedItem = createSelector([selectShippingModes], (shippingModes) => shippingModes.create);

export const selectShippingModesUpdatedItem = createSelector([selectShippingModes], (shippingModes) => shippingModes.update);

export const selectShippingModesReadItem = createSelector([selectShippingModes], (shippingModes) => shippingModes.read);

export const selectShippingModesDeletedItem = createSelector([selectShippingModes], (shippingModes) => shippingModes.delete);

export const selectShippingModesSearchedItems = createSelector([selectShippingModes], (shippingModes) => shippingModes.search);

export const selectShippingModesItemsCount = createSelector([selectShippingModes], (shippingModes) => shippingModes.count);

export const selectShippingModesItemsFilter = createSelector([selectShippingModes], (shippingModes) => shippingModes.filter);